import MenuPopover from 'src/components/menu_popover/menu_popover.vue'
import ScopeSelector from 'src/components/scope_selector/scope_selector.js'

import {
  SCOPES,
  visibilityIcon,
} from 'src/services/status_visibility/status_visibility.js'

// The scope picker: one labelled button and a menu. It shares the rules
// for which scopes to offer with ScopeSelector.
const ScopeMenu = {
  extends: ScopeSelector,
  components: { MenuPopover },
  props: {
    // the menu stays inside the closest element matching this
    within: { type: String, default: '.composer-box' },
  },
  computed: {
    scopes() {
      const shown = {
        public: this.showPublic,
        unlisted: this.showUnlisted,
        local: this.showLocal,
        private: this.showPrivate,
        direct: this.showDirect,
      }
      return SCOPES.filter((scope) => shown[scope])
    },
    items() {
      return this.scopes.map((scope) => ({
        key: scope,
        label: this.$t(`general.scope_in_timeline.${scope}`),
        description: this.$t(`post_status.scope_description.${scope}`),
        icon: this.icon(scope),
        radio: true,
        mark: false,
        checked: scope === this.currentScope,
        action: () => this.changeVis(scope),
      }))
    },
  },
  methods: {
    icon: visibilityIcon,
  },
}

export default ScopeMenu
